// extracted by mini-css-extract-plugin
export default {"login":"style_login__iWjNh","outerBox":"style_outerBox__rVVf8","formdiv":"style_formdiv__BLjhH","username":"style_username__RUAHj"};